export function referenceElement(reference) {
  console.log("called 111");
  if (reference) {
    const { id, name, relationship, email, phone, url } = reference;
    return `
    <div class="reference-details-item">
        <input type="hidden" name="id" class="reference_id" value="${id}">
        <div class="reference-item-top">
          <div class="form-group">
            <label>Name <span>*</span></label>
            <input type="text" name="name" value="${name}" class="form-control name" required>
          </div>
          <div class="form-group">
            <label>Relationship <span>*</span></label>
            <input type="text" name="relationship" value="${relationship}" class="form-control relationship" required>
          </div>
        </div>
        <div class="reference-item-bottom">
          <div class="form-group">
            <label>Email <span>*</span></label>
            <input type="email" name="email" value="${email}" class="form-control email" required>
          </div>
          <div class="form-group">
            <label>Phone Number</label>
            <input type="text" name="phone" value="${phone}" class="form-control numberonlyField phone" minlength="8" maxlength="14">
          </div>
          <a href="${url}" class="remove-reference-details"><i class="fas fa-times"></i></a>
        </div>
      </div>
  `;
  }
  return `
    <div class="reference-details-item">
        <input type="hidden" name="id" class="reference_id">
        <div class="reference-item-top">
          <div class="form-group">
            <label>Name <span>*</span></label>
            <input type="text" name="name" class="form-control name" required>
          </div>
          <div class="form-group">
            <label>Relationship <span>*</span></label>
            <input type="text" name="relationship" class="form-control relationship" required>
          </div>
        </div>
        <div class="reference-item-bottom">
          <div class="form-group">
            <label>Email <span>*</span></label>
            <input type="email" name="email" class="form-control email" required>
          </div>
          <div class="form-group">
            <label>Phone Number</label>
            <input type="text" name="phone" class="form-control numberonlyField phone" minlength="8" maxlength="14">
          </div>
          <a href="#" class="remove-reference-details"><i class="fas fa-times"></i></a>
        </div>
      </div>
  `;
}
